/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Wild type
 */
export type CreateReportDtoWildType =
  (typeof CreateReportDtoWildType)[keyof typeof CreateReportDtoWildType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateReportDtoWildType = {
  freeRoaming: 'freeRoaming',
  captive: 'captive',
  feral: 'feral',
} as const;
